import React, { useState } from "react";
import { ColumnValueRendererProps, LongTextColumnValue } from "../table.data.interface";
import { DropdownChevronDown } from "@vibe/icons";
import { Tooltip } from "@vibe/core";

const LongTextColumn = ({ columnData, isPreview, otherBoardsValues }: ColumnValueRendererProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [expand, setExpand] = useState(false);

  if (
    columnData.value === "Empty Column" ||
    (!columnData.text && isPreview) ||
    (!columnData?.value && otherBoardsValues)
  ) {
    return null;
  }

  const handleExpand = () => {
    try {
      setExpand(!expand);
    } catch (error) {}
  };

  if (isPreview) {
    return (
      <Tooltip content={columnData?.text as string}>
        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
          <span>{columnData?.text as string}</span>
        </div>
      </Tooltip>
    );
  }

  const value = otherBoardsValues
    ? (columnData?.value as LongTextColumnValue)?.text
    : columnData?.value;

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`flex items-center justify-center p-2 transition overflow-hidden cursor-pointer rounded ${isHovered ? "bg-[#f5f6f8]" : ""} ${
        expand ? "bg-[#f5f6f8] max-h-[400px]" : "max-h-[36px] whitespace-nowrap text-ellipsis"
      }`}
    >
      <div
        className={`${expand ? "text-wrap" : "overflow-hidden whitespace-nowrap cursor-pointer text-ellipsis"}`}
      >
        <span>{value as string}</span>
      </div>
      <span className="flex justify-center items-center self-start">
        <DropdownChevronDown
          onClick={() => {
            handleExpand();
          }}
          color=""
          className={`transition duration-300 ${isHovered ? "opacity-100" : "opacity-0"} ${expand ? "opacity-100 -rotate-180" : "rotate-0"}`}
        />
      </span>
    </div>
  );
};

export default LongTextColumn;
